import { render, staticRenderFns } from "./guests.vue?vue&type=template&id=889c8a0a&scoped=true"
import script from "./guests.vue?vue&type=script&lang=js"
export * from "./guests.vue?vue&type=script&lang=js"
import style0 from "./guests.vue?vue&type=style&index=0&id=889c8a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889c8a0a",
  null
  
)

export default component.exports